import { ManageHostManagementContainer } from '@/features/store-management/basic-stores/ManageHostManagementContainer';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores/host-management/$clubid/$manage-host/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ManageHostManagementContainer />;
}
